module.exports = __webpack_public_path__ + "static/img/2492b40.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/sendPoints/qr.png
// module id = 689
// module chunks = 2